import { User } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

export interface Member {
  id: number;
  name: string;
  email: string;
  role: "owner" | "admin" | "member";
  avatar_url?: string;
  is_current_user: boolean;
}

interface MemberSelectProps {
  members: Member[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  filterFn?: (member: Member) => boolean;
  className?: string;
}

export function MemberSelect({
  members,
  value,
  onValueChange,
  placeholder = "Select a member",
  disabled = false,
  filterFn = (member) => !member.is_current_user && member.role !== "owner",
  className = "",
}: MemberSelectProps) {
  const eligibleMembers = members.filter(filterFn);

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        leftIcon={<User className="w-4 h-4" />}
        disabled={disabled}
        className={className}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {eligibleMembers.map((member) => (
          <SelectItem key={member.id} value={member.id.toString()}>
            <div className="flex items-center gap-2">
              <span className="font-medium">{member.name}</span>
              <span className="text-gray-500 text-sm">
                ({member.email})
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}